import { render, staticRenderFns } from "./LifterApprovals.vue?vue&type=template&id=f30b3c8a&"
import script from "./LifterApprovals.vue?vue&type=script&lang=js&"
export * from "./LifterApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports